import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { Manager, Reference, Popper } from 'react-popper';
import { Icon } from '@grandvisionhq/icons';
import { useIntl } from '@grandvisionhq/state';
import { parseHtml } from '@grandvisionhq/utils';
import { useBreakpoint, BreakpointName } from '../MediaQuery/MediaQueryContext.js';
import { isTouchDevice } from '../Util/is-touch-device.js';

const Tooltip = (_param)=>{
    var { message , id , className , placement: placement1 = 'top' , parseHtml: parseHtml$1 =false , dashed , label , greyedOut , boundariesElement ='scrollParent'  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "message",
        "id",
        "className",
        "placement",
        "parseHtml",
        "dashed",
        "label",
        "greyedOut",
        "boundariesElement"
    ]);
    const { getLabel  } = useIntl();
    const currentBreakpoint = useBreakpoint();
    const [isActive1, setIsActive] = React.useState(false);
    const [tooltipHovered, setTooltipHovered] = React.useState(false);
    const isTouch = React.useMemo(()=>isTouchDevice()
    , []);
    const triggerRef = React.useRef(null);
    // Touch device handlers
    const handleDocumentClick = React.useCallback((e)=>{
        // Check if the clicked target is not equal to our trigger, preventing the tooltip to re-open immediately
        setIsActive((isActive)=>{
            if (isActive && triggerRef.current && !triggerRef.current.contains(e.target)) {
                return false;
            }
            return isActive;
        });
    }, []);
    React.useEffect(()=>{
        if (!isTouch) {
            return;
        }
        document.addEventListener('touchend', handleDocumentClick);
        return ()=>document.removeEventListener('touchend', handleDocumentClick)
        ;
    }, [
        isTouch,
        handleDocumentClick
    ]);
    const handleTriggerClick = React.useCallback(()=>{
        isTouch && setIsActive((isActive)=>!isActive
        );
    }, [
        isTouch
    ]);
    // Non-touch handlers
    const handleTriggerMouseOver = React.useCallback(()=>{
        !isTouch && setIsActive(true);
    }, [
        isTouch
    ]);
    const handleTriggerMouseLeave = React.useCallback(()=>{
        // this timeout allows a user to move it's cursor from the trigger to the tooltip to keep the tooltip open
        !isTouch && setTimeout(()=>setIsActive(false)
        , 100);
    }, [
        isTouch
    ]);
    const handleTooltipMouseOver = React.useCallback(()=>{
        !isTouch && setTooltipHovered(true);
    }, [
        isTouch
    ]);
    const handleTooltipMouseLeave = React.useCallback(()=>{
        !isTouch && setTooltipHovered(false);
    }, [
        isTouch
    ]);
    const handleKeyPress = (e)=>{
        if (e.key === 'Enter') {
            !isTouch && setIsActive(true);
            if (!isTouch && isActive1) {
                setIsActive(false);
            }
        }
        if (e.key === 'Escape') {
            setIsActive(false);
        }
    };
    const renderDashed = dashed && (currentBreakpoint === BreakpointName.DESKTOP || currentBreakpoint === BreakpointName.TABLET_LANDSCAPE);
    const buttonClass = classnames({
        tooltip__button: !renderDashed,
        'tooltip__button--active': isActive1 && !renderDashed,
        'tooltip__button--greyed-out': !dashed && greyedOut,
        tooltip__dashed: renderDashed
    });
    if (!message) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames('tooltip', className)
    }, /*#__PURE__*/ React.createElement(Manager, null, /*#__PURE__*/ React.createElement(Reference, null, ({ ref  })=>/*#__PURE__*/ React.createElement("div", {
            ref: triggerRef
        }, /*#__PURE__*/ React.createElement("div", {
            className: "tooltip__container"
        }, /*#__PURE__*/ React.createElement("button", {
            type: "button",
            "aria-label": rest['aria-label'] || getLabel('common.tooltip'),
            "aria-describedby": id,
            "aria-expanded": isActive1,
            className: buttonClass,
            ref: ref,
            onClick: handleTriggerClick,
            onMouseOver: handleTriggerMouseOver,
            onMouseLeave: handleTriggerMouseLeave,
            onFocus: ()=>null
            ,
            onKeyUp: handleKeyPress
        }, renderDashed && label, !renderDashed && /*#__PURE__*/ React.createElement(Icon, {
            name: "questionmark"
        }))))
    ), /*#__PURE__*/ React.createElement("div", {
        "aria-live": "polite",
        id: id
    }, (isActive1 || tooltipHovered) && /*#__PURE__*/ React.createElement(Popper, {
        placement: placement1,
        modifiers: {
            preventOverflow: {
                enabled: true,
                boundariesElement,
                padding: 0
            }
        }
    }, ({ ref , style , placement  })=>/*#__PURE__*/ React.createElement("div", {
            "aria-hidden": !isActive1,
            ref: ref,
            style: style,
            "data-placement": placement,
            className: "tooltip__message",
            onMouseOver: handleTooltipMouseOver,
            onMouseLeave: handleTooltipMouseLeave,
            onFocus: ()=>null
            ,
            onBlur: ()=>setIsActive(false)
        }, typeof message === 'string' ? /*#__PURE__*/ React.createElement("div", null, parseHtml$1 ? parseHtml(message) : message) : /*#__PURE__*/ React.isValidElement(message) && message)
    ))));
};
var Tooltip$1 = Tooltip;

export { Tooltip$1 as default };
//# sourceMappingURL=Tooltip.js.map
